import { createAction } from 'redux-actions'

const ns = 'forgot-password/'

export const startResetPassword = createAction(`${ns}START_RESET_PASSWORD`)
export const startResetPasswordFail = createAction(`${ns}START_RESET_PASSWORD_FAIL`)
export const resetForgotPasswordState = createAction(`${ns}RESET_STATE`)
